import { Equals, IsBoolean } from 'class-validator';

export class UpdateCookieSettingsDto {
	@IsBoolean()
	@Equals(true)
	essential: true;

	@IsBoolean()
	preference: boolean;

	@IsBoolean()
	performance: boolean;

	@IsBoolean()
	marketing: boolean;
}
